export default {
  isolateList: [],
  isolateSelected: null,
  isolatesList: [],
  count: 0,
};
